import React, { useState, useEffect } from 'react';
import { Shield, Check, Clock, User, Building, Mail, Calendar } from 'lucide-react';
import api from '../../lib/api';
import { toast } from 'sonner';

export default function AdminDPA() {
  const [dpas, setDpas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [countersigning, setCountersigning] = useState(null);

  useEffect(() => {
    loadDPAs();
  }, []);

  const loadDPAs = async () => {
    try {
      const res = await api.get('/api/admin/dpa/pending');
      setDpas(res.data.dpas || []);
    } catch {} finally { setLoading(false); }
  };

  const handleCountersign = async (dpaId) => {
    setCountersigning(dpaId);
    try {
      await api.post(`/api/admin/dpa/${dpaId}/countersign`);
      toast.success('DPA countersigned successfully');
      loadDPAs();
    } catch {
      toast.error('Failed to countersign DPA');
    } finally {
      setCountersigning(null);
    }
  };

  if (loading) return <div className="page-content"><p>Loading...</p></div>;

  return (
    <div className="page-content" style={{ maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 'clamp(1.25rem, 4vw, 1.75rem)', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 8px', display: 'flex', alignItems: 'center', gap: 8 }}>
        <Shield size={24} color="var(--accent-primary)" /> DPA Agreements
      </h1>
      <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 32 }}>
        {dpas.length} agreement{dpas.length !== 1 ? 's' : ''} awaiting countersignature
      </p>

      {dpas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-tertiary)' }}>
          <Check size={48} style={{ marginBottom: 12 }} />
          <p>All DPAs are up to date. No pending agreements.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {dpas.map(dpa => (
            <div key={dpa.id} style={{
              background: 'var(--bg-secondary)', border: '1px solid var(--border-primary)', borderRadius: 14, padding: '20px 24px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16
            }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: 'var(--accent-glow)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Building size={20} color="var(--accent-primary)" />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 14 }}>{dpa.company_name || 'Unknown Company'}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: 4 }}>
                      <User size={12} /> {dpa.signer_name || dpa.user_name || '—'}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 11, color: 'var(--text-tertiary)' }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Mail size={11} /> {dpa.user_email || dpa.signer_email || '—'}</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Calendar size={11} /> Signed {dpa.signed_at ? new Date(dpa.signed_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—'}</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Clock size={11} /> {dpa.signer_title || '—'}</span>
                </div>
              </div>
              <button
                onClick={() => handleCountersign(dpa.id)}
                disabled={countersigning === dpa.id}
                style={{
                  padding: '10px 20px', borderRadius: 10, border: 'none',
                  background: countersigning === dpa.id ? 'var(--bg-tertiary)' : 'var(--success)',
                  color: countersigning === dpa.id ? 'var(--text-tertiary)' : '#fff',
                  cursor: countersigning === dpa.id ? 'wait' : 'pointer',
                  fontSize: 13, fontWeight: 600, fontFamily: 'inherit', whiteSpace: 'nowrap',
                  display: 'flex', alignItems: 'center', gap: 6
                }}>
                {countersigning === dpa.id ? 'Signing...' : <><Check size={14} /> Countersign</>}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
